<template>
  <div
    ref="chartTitle"
    class="
      items-center
      text-xs
      font-bold
      uppercase
      tracking-wide
      opacity-50
      chart-title
      my-1
      flex-auto
    "
  >
    {{ titleToDisplay }}
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FontSizeAdjustMixin from '@/mixins/FontSizeAdjustMixin'

export default {
  mixins: [FontSizeAdjustMixin],
  props: {
    titleText: String,
    defaultTitleText: String,
    embedded: Boolean,
  },
  data() {
    return {
      titleTextConfig: {
        maxFontSize: 20,
        elementName: 'chartTitle',
      },
    }
  },
  watch: {
    storedTitleText() {
      this.$nextTick(this.onTitleVisible)
    },
  },
  computed: {
    titleToDisplay() {
      let title
      if (this.embedded) {
        title = this.titleText || this.defaultTitleText
      } else {
        title = this.storedTitleText || this.defaultTitleText
      }
      if (!title) {
        return ''
      }
      return title.substring(0, this.maxTitleLength)
    },
    ...mapState({
      maxTitleLength: (state) => state.ChartCategory.maxTitleLength,
      storedTitleText: (state) => state.ChartCategory.titleText,
    }),
  },
  methods: {
    onTitleVisible() {
      this.scaleText(this.titleTextConfig)
    },
  },
}
</script>
<style lang="postcss" scoped>
.chart-title {
  flex-shrink: 0;
}
</style>
